import './CoralUVP.scss'
import '../../../coral-library/css/_layout.scss'

import { CoralCardsSlider } from '@websrc/App/Components/CoralCardsSlider/CoralCardsSlider'
import { mapCoralWebUvp } from '@websrc/DataMappers/mapSpot'
import React, { FC, useEffect } from 'react'

import { CoralUVPFlipCard } from '../../../coral-library/cards/FlipCards/CoralParagraphFlipCard/CoralUVPFlipCard'

type CoralUVPProps = ReturnType<typeof mapCoralWebUvp>

export const CoralUVP: FC<CoralUVPProps> = (props) => {
  const syncHeadlineHeights = () => {
    const headers = document.querySelectorAll<HTMLElement>('.coral-uvp-flip-card__front-headline')
    let maxHeight = 0
    headers.forEach((header) => {
      header.style.minHeight = ''
    })
    headers.forEach((header) => {
      const height = header.offsetHeight
      if (height > maxHeight) maxHeight = height
    })
    headers.forEach((header) => {
      header.style.minHeight = `${maxHeight}px`
    })
  }

  useEffect(() => {
    syncHeadlineHeights()
    window.addEventListener('resize', syncHeadlineHeights)
    return () => {
      window.removeEventListener('resize', syncHeadlineHeights)
    }
  }, [props.flip_cards])

  return (
    <div className={'category-coral-spot'}>
      <div className={'coral-uvp'}>
        <CoralCardsSlider>
          {props.flip_cards.map((card, id) => (
            <CoralUVPFlipCard key={id} {...card} />
          ))}
        </CoralCardsSlider>
      </div>
    </div>
  )
}
